import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export function BackToTop() {
  const [show, setShow] = useState(false);
  // Round 3 Agent C (item #16): track soft-keyboard state via visualViewport
  // so the FAB drops out of the way while a user is typing into a form
  // field on mobile. Mirrors the heuristic MobileBottomBar uses (>20% shrink
  // of visualViewport.height vs window.innerHeight).
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 800);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const vv = typeof window !== "undefined" ? window.visualViewport : null;
    if (!vv) return;
    const check = () => {
      const layoutH = window.innerHeight;
      const visualH = vv.height;
      if (!layoutH) return;
      setKeyboardOpen((layoutH - visualH) / layoutH > 0.2);
    };
    check();
    vv.addEventListener("resize", check);
    vv.addEventListener("scroll", check);
    return () => {
      vv.removeEventListener("resize", check);
      vv.removeEventListener("scroll", check);
    };
  }, []);

  // Round 3 Agent C (item #8): respect reduced-motion. The smooth scroll
  // animation can trigger vestibular discomfort; fall back to instant jump.
  const handleClick = () => {
    const reduce =
      typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      className={`back-top ${show ? "is-visible" : ""} ${keyboardOpen ? "is-keyboard-open" : ""}`}
      aria-label="Back to top"
      onClick={handleClick}
    >
      <ArrowUp aria-hidden="true" />
    </button>
  );
}
